import { useAuth } from '#imports';

export function useIsGranted() {
  const { data: session, status } = useAuth();

  const roleHierarchy: Record<string, string[]> = {
    ROLE_SUPER_ADMIN: ['ROLE_SUPER_ADMIN', 'ROLE_ORG_ADMIN', 'ROLE_ORG_SCANNER'],
    ROLE_ORG_ADMIN: ['ROLE_ORG_ADMIN', 'ROLE_ORG_SCANNER'],
    ROLE_ORG_SCANNER: ['ROLE_ORG_SCANNER'],
  };

  const getEffectiveRoles = (userRoles: string[]): string[] => {
    const effective = new Set<string>();
    for (const role of userRoles) {
      const inherited = roleHierarchy[role] ?? [role];
      inherited.forEach((r) => effective.add(r));
    }
    return Array.from(effective);
  };

  const isGranted = (role: string): boolean => {
    if (status.value !== 'authenticated') {
      return false;
    }
    const userRoles = session?.value?.roles ?? [];
    const effectiveRoles = getEffectiveRoles(userRoles);
    return effectiveRoles.includes(role);
  };

  return {
    isGranted,
  };
}
